export default {
  'nav.home': 'Home',
  'nav.shoppingGuide': 'Shopping Guide',
  'nav.categories': 'Categories',
  'nav.faq': 'FAQ',
  'nav.mainSite': 'Visit Main Website',
  'nav.language': 'Language',

  'hero.eyebrow': 'Independent Resource · Updated 2026',
  'hero.title': 'Basetao Spreadsheet Guide',
  'hero.subtitle':
    'Find, compare and organize products with practical Basetao Spreadsheet resources, product research guides, finds, shipping info and reviews — all in one independent place.',
  'hero.ctaPrimary': 'basetao spreadsheet',
  'hero.ctaSecondary': 'buy it now',
  'hero.ctaGuide': 'Explore the full guide',

  'categories.title': 'Browse by Category',
  'categories.subtitle':
    'Pick a category below to jump straight to curated product lists on the main website.',
  'categories.dropdownLabel': 'Select a category',

  'guide.title': 'What Is a Basetao Spreadsheet?',
  'guide.lead':
    'A Basetao spreadsheet is a simple way to organize the products you find, compare prices and sellers, and keep every link and shipping detail in one clean place.',

  'article.title': 'Explore the Basetao Guides',
  'article.subtitle': 'Ten in-depth pillar guides to help you research, ship and save smarter.',
  'article.readMore': 'Read article',

  'faq.title': 'Frequently Asked Questions',
  'faq.subtitle': 'Quick answers about Basetao Spreadsheet and this site.',

  'cta.title': 'Ready to keep researching?',
  'cta.subtitle':
    'Continue your product research with our guides, or head to the main website to start building your own finds.',
  'cta.mainSite': 'Visit Main Website',
  'cta.guide': 'Continue Your Research',

  'footer.tagline':
    'An independent informational resource about the Basetao Spreadsheet. Not affiliated with or endorsed by Basetao.',
  'footer.resources': 'Resources',
  'footer.company': 'Company',
  'footer.languages': 'Languages',
  'footer.disclaimer':
    'Basetao Sheet Guide is an independent informational website and is not affiliated with or endorsed by Basetao unless explicitly stated.',

  'hero.demoLabel': 'Demo data shown for illustration only.',
  'guide.readFullGuide': 'Read the full guide',
  'guide.exampleLabel': 'Example spreadsheet structure (demo data)',

  'article.faqTitle': 'Frequently Asked Questions',
  'article.relatedTitle': 'Related Guides',
  'article.ctaTitle': 'Continue your research',
  'article.ctaText':
    'Ready to start adding products to your sheet? Explore the categories or head back to the homepage for more resources.',
  'article.backToHome': 'Back to Home',
  'article.visitMainSite': 'Visit Main Website',
  'article.author': 'Basetao Sheet Guide Team',

  'notFound.title': 'Article not found',
  'notFound.text':
    'The page you are looking for does not exist. Head back to the homepage to explore our guides.',
  'notFound.backToHome': 'Back to Home',

  'home.metaDescription':
    'Explore Basetao Spreadsheet guides, finds, reviews, shipping costs, warehouse information, QC tips, coupons and practical resources.',
};